import { ToastQueue } from "@react-spectrum/toast";

export const errorToast = (value: string) => {
  ToastQueue.negative(value, {
    timeout: 5000,
  });
};

export const successToast = (value: string) => {
  ToastQueue.positive(value, {
    timeout: 5000,
  });
};

export const warningToast = (value: string) => {
  ToastQueue.neutral(value, {
    timeout: 5000,
  });
};
